import React from 'react';
import PropTypes from "prop-types";
import styled from 'styled-components';
import RitModal from '../RitModal';

const ErrorMessage = styled.h2`
    font-size: 16px;
    color: brown;
    margin: 16px;
    text-align: center;
`;

const DEFAULT_ERROR_TITLE = 'Не удалось добавить рубашку в корзину';

const CartErrorModal = ({ title, isOpened, onClose, closeOnEsc, errorMessage }) => {
    return (
        <RitModal
            title={title || DEFAULT_ERROR_TITLE}
            isOpened={isOpened}
            onClose={onClose}
            closeOnEsc={closeOnEsc}
        >
            <ErrorMessage>{errorMessage}</ErrorMessage>
        </RitModal>
    )
}

CartErrorModal.propTypes = {
    title: PropTypes.string, 
    isOpened: PropTypes.bool.isRequired, 
    onClose: PropTypes.func.isRequired, 
    closeOnEsc: PropTypes.bool, 
    errorMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]),
}

export default CartErrorModal;